var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconCasino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.293 10c0-4.773 3.894-8.667 8.667-8.667S19.627 5.227 19.627 10s-3.894 8.667-8.667 8.667S2.293 14.773 2.293 10zm21.134 12.867l-5.612-5.614A9.842 9.842 0 0020.96 10c0-5.52-4.479-10-10-10s-10 4.48-10 10 4.479 10 10 10a9.92 9.92 0 005.84-1.893l5.693 5.693c.12.133.294.2.467.2a.625.625 0 00.467-.2.644.644 0 000-.933z",
    fill: "#999"
  })));
}
SvgSearchIconCasino.displayName = 'SearchIconCasino';
export default SvgSearchIconCasino;